import { render } from "./BarmanEditor.vue?vue&type=template&id=2a8cb6f5&scoped=true"
import script from "./BarmanEditor.vue?vue&type=script&lang=js"
export * from "./BarmanEditor.vue?vue&type=script&lang=js"

import "./BarmanEditor.vue?vue&type=style&index=0&id=2a8cb6f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8cb6f5"]])

export default __exports__